import React from 'react';
import { Box, ButtonBase, GlobalStyles, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { WbSunnyOutlined, TrackChanges, CandlestickChart, ListAlt, MoreHoriz } from '@mui/icons-material';

// Phone navigation (DWLF-307; canvas board MobileBrief): the decision loop as a bottom tab bar —
// Today · Markets · Chart · Log — within thumb reach, with More opening the full menu (Signals, Build,
// account). The top bar keeps search and the menu; this repeats the four places a phone user lives.

const BAR_H = 56;
const tok = (t) => `var(--dwlf-${t})`;

export default function MobileTabBar({ tabs, onMore }) {
  return (
    <>
      {/* Keep page content clear of the fixed bar, including the home-indicator inset. */}
      <GlobalStyles styles={{ body: { paddingBottom: `calc(${BAR_H}px + env(safe-area-inset-bottom))` } }} />
      <Box component="nav" aria-label="Main"
        sx={{
          position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: (t) => t.zIndex.appBar,
          display: 'grid', gridTemplateColumns: `repeat(${tabs.length + 1}, 1fr)`,
          height: `calc(${BAR_H}px + env(safe-area-inset-bottom))`, pb: 'env(safe-area-inset-bottom)',
          backgroundColor: tok('surface'), borderTop: `1px solid ${tok('ink-10')}`,
        }}>
        {tabs.map((t) => (
          <ButtonBase key={t.label} component={RouterLink} to={t.path} aria-current={t.active ? 'page' : undefined}
            sx={{ flexDirection: 'column', gap: 0.25, color: tok(t.active ? 'accent' : 'ink-60'),
              borderTop: `2px solid ${t.active ? tok('accent') : 'transparent'}` }}>
            {t.icon}
            <Typography component="span" sx={{ fontFamily: '"Space Mono", monospace', fontSize: '0.5625rem', letterSpacing: '0.12em', textTransform: 'uppercase' }}>
              {t.label}
            </Typography>
          </ButtonBase>
        ))}
        <ButtonBase onClick={onMore} aria-label="More: signals, build and account"
          sx={{ flexDirection: 'column', gap: 0.25, color: tok('ink-60'), borderTop: '2px solid transparent' }}>
          <MoreHoriz />
          <Typography component="span" sx={{ fontFamily: '"Space Mono", monospace', fontSize: '0.5625rem', letterSpacing: '0.12em', textTransform: 'uppercase' }}>More</Typography>
        </ButtonBase>
      </Box>
    </>
  );
}

export const tabIcons = { today: <WbSunnyOutlined />, markets: <TrackChanges />, chart: <CandlestickChart />, log: <ListAlt /> };
